<template>
  <section class="">
    <b-row class="">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="12" md="12">
        <b-card-actions action-collapse title="Edit Booking">
          <b-row class="">
            <b-col cols="12" xl="12" md="12" class="mt-15">
              <h5>Reference</h5>
            </b-col>
            <b-col lg="12" md="12" sm="12" xs="12" cols="12">
              <b-form-group label-for="reference">
                <b-form-input
                  v-model="form.reference"
                  placeholder="Reference"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Route</h5>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-input
                id="item-from"
                v-model="form.loadingPort"
                label="title"
                placeholder="From"
                disabled
              ></b-form-input>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-input
                id="item-To"
                v-model="form.dischargePort"
                label="title"
                placeholder="To"
                disabled
              ></b-form-input>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-15">
              <v-select
                id="item-Incoterm"
                v-model="form.incoterm"
                label="item-Incoterm"
                placeholder="Incoterm"
                :options="incotermArray"
                @input="updateIncoterm(form.incoterm)"
              >
              </v-select>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="form.incoterm == 'EXW' || form.incoterm == 'FCA'"
            >
              <b-form-group label-for="Incoterm">
                <v-select
                  id="Incoterm"
                  v-model="form.transportType"
                  :options="TransportLoadingOptions"
                  required
                  class="input-outline-bleu-border"
                  placeholder="Transport Type"
                  @input="updateTransport(form.transportType)"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="
                form.transportType == 'Transport Marchant' &&
                (form.incoterm == 'EXW' || form.incoterm == 'FCA')
              "
            >
              <b-form-group label-for="departureAddressCity">
                <b-form-input
                  v-model="form.departureAddressCity"
                  placeholder="Adresse Depart City"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="form.incoterm == 'DAP'"
            >
              <b-form-group label-for="Incoterm">
                <v-select
                  id="Incoterm"
                  v-model="form.transportType"
                  :options="TransportLoadingOptions"
                  required
                  class="input-outline-bleu-border"
                  placeholder="Transport Type"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="
                form.transportType == 'Transport Marchant' &&
                form.incoterm == 'DAP'
              "
            >
              <b-form-group label-for="arrivalAddressCity">
                <b-form-input
                  v-model="form.arrivalAddressCity"
                  placeholder="adresse Arrival City"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Commodity/Container</h5>
            </b-col>
            <b-col cols="12" xl="12" md="12">
              <b-row
                v-for="(item, index) in form.commodityContainer"
                :key="index"
              >
                <b-col cols="12" xl="12" md="12" class="mt-30">
                  <h5>Commodity</h5>
                </b-col>
                <b-col cols="12" xl="12" md="12">
                  <v-select
                    id="item-Commodity"
                    v-model="item.commodity.title"
                    label="title"
                    placeholder="Commodity"
                    :options="commodities"
                  >
                    <template #list-header>
                      <li
                        v-b-toggle.sidebar-add-new-commodity
                        class="add-new-header d-flex align-items-center my-50 pl-1"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25">Add commodity</span>
                      </li>
                    </template>
                  </v-select>
                </b-col>
                <b-col cols="12" xl="12" md="12" class="mt-15">
                  <b-form-group>
                    <b-form-radio-group class="commodity-radio-group">
                      <b-form-radio
                        v-model="item.selectedOption"
                        value="radio1"
                        @change="updateSelectedOption(index)"
                      >
                        Peperishable cargo requiring temperature control
                      </b-form-radio>
                      <b-form-radio
                        v-model="item.selectedOption"
                        value="radio2"
                        @change="updateSelectedOption(index)"
                      >
                        Cargo requiring special equipment
                      </b-form-radio>
                      <b-form-radio
                        v-model="item.selectedOption"
                        value="radio3"
                        @change="updateSelectedOption(index)"
                      >
                        Dangerous Cargo
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio1'"
                >
                  <b-form-group>
                    <b-form-input
                      id="temperature"
                      placeholder="Temperature"
                      v-model="item.commodity.temperatureControl"
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="4"
                  md="4"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio2'"
                >
                  <b-form-group>
                    <b-form-input
                      id="height"
                      placeholder="Height"
                      v-model="item.commodity.specialEquipment.height"
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="4"
                  md="4"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio2'"
                >
                  <b-form-group>
                    <b-form-input
                      id="width"
                      placeholder="Width"
                      v-model="item.commodity.specialEquipment.width"
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="4"
                  md="4"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio2'"
                >
                  <b-form-group>
                    <b-form-input
                      id="length"
                      placeholder="Length"
                      v-model="item.commodity.specialEquipment.length"
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="6"
                  md="6"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio3'"
                >
                  <b-form-group label-for="classe">
                    <v-select
                      id="classe"
                      v-model="item.commodity.commodityClass"
                      :options="classes"
                      label="title"
                      required
                      placeholder="classe"
                      class="input-outline-bleu-border"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col
                  lg="6"
                  md="6"
                  sm="6"
                  xs="12"
                  cols="12"
                  v-if="item.selectedOption == 'radio3'"
                >
                  <b-form-group label-for="un">
                    <v-select
                      id="un"
                      v-model="item.commodity.commodityUn"
                      :options="uns"
                      placeholder="UN"
                      required
                      label="title"
                      class="input-outline-bleu-border"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="12" md="12" class="mt-30">
                  <h5>Container</h5>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group label-for="container">
                    <v-select
                      id="container"
                      v-model="item.container.containerType"
                      :options="item.container.containers"
                      required
                      placeholder="Container type"
                      class="input-outline-bleu-border"
                      @input="
                        updateContainer(index, item.container.containerType)
                      "
                    ></v-select>
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox
                      value="true"
                      v-model="item.container.isOwnedByShipper"
                      >Shipper owned container</b-form-checkbox
                    >
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" cols="12">
                  <b-form-group label-for="Container-qte">
                    <b-form-spinbutton
                      id="Container-qte"
                      v-model="item.container.quantity"
                      min="1"
                      max="100000"
                      class="input-outline-bleu-border"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" cols="12">
                  <b-form-group label-for="Container-quantity">
                    <b-form-input
                      placeholder="Container weight ( kg )"
                      v-model="item.container.weight"
                      @change="financial(item)"
                      required
                      id="Container-quantity"
                      disable
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="2" md="2" sm="12" xs="12" cols="12" v-if="index > 0">
                  <b-button
                    variant="danger"
                    class="addContainer"
                    @click="deleteCommodityContainer(index)"
                  >
                    Delete
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button
                    variant="primary"
                    class="addContainer"
                    @click="addCommodityContainer()"
                  >
                    Add an additional container
                  </b-button>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Date</h5>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-datepicker
                id="Effective-datepicker"
                v-model="form.effectiveDate"
                class="mb-1"
                placeholder="Effective date"
              />
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-datepicker
                id="Expiry-datepicker"
                v-model="form.expiryDate"
                class="mb-1"
                placeholder="Expiry date"
              />
            </b-col>
            <!-- <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Price Owner</h5>
            </b-col>
            <b-col lg="5" md="6" sm="6" xs="12" cols="12">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="selectedOption" :aria-describedby="ariaDescribedby" name="customer" value="iamPriceOwner" @input="changeRadio" class="mb-1">I am the price Owner</b-form-radio>
                <b-form-radio v-model="selectedOption" :aria-describedby="ariaDescribedby" name="priceOwner" value="selectPriceOwner" @input="changeRadio">Select a price Owner</b-form-radio>
              </b-form-group>
            </b-col> -->
            <!-- <b-row v-if="selectedOption === 'selectPriceOwner'" class="customer-row">  
              <b-col cols="12" xl="12" md="12" class="mt-30">
                                          <h5>Customer Code</h5>
                                        </b-col>                      
                                           <b-col lg="12" md="12" sm="12" xs="12" cols="12">      
                                                                            
                                                    <b-form-group label-for="customerCode">
                                                        <b-form-input
                                                        id="customerCode"
                                                        v-model="form.customerCode"
                                                        placeholder="Customer Code"
                                                        required
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                            </b-col>

                                             <b-col lg="5" md="5" sm="12" xs="12" cols="12" class="mt-25 mb-25">
                                               <hr>
                                            </b-col>
                                            <b-col  lg="1" md="1" sm="1" xs="12" cols="12" class="mt-25 mb-25">Or</b-col>
                                            <b-col lg="6" md="5" sm="12" xs="12" cols="12" class="mt-25 mb-25">
                                               <hr>
                                            </b-col>
                                         
                                            <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                              <b-col cols="12" xl="6" md="6" class="mt-30">
                                          <h5>Company Name</h5>
                                        </b-col>
                                                <b-form-group label-for="companyName" >
                                                        <b-form-input
                                                        v-model="form.companyName"
                                                        placeholder="Company Name"
                                                        required
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                             </b-col>
                                         
                                              <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                <b-col cols="12" xl="6" md="6" class="mt-30">
                                          <h5>Country</h5>
                                        </b-col>
                                                <b-form-group label-for="country">
                                                    <b-form-input
                                                    id="country"
                                                    v-model="form.country"
                                                    placeholder="Country"
                                                    required
                                                     class="input-outline-bleu-border"
                                                    ></b-form-input>
                                               </b-form-group>
                                            </b-col>
                                          
                                            <b-col lg="6" md="6" sm="6" xs="6" cols="12" >
                                              <b-col cols="12" xl="12" md="12" class="mt-30">
                                          <h5>Postal/Zip code(Optional)</h5>
                                        </b-col>
                                                <b-form-group label-for="postal" >
                                                        <b-form-input
                                                        v-model="form.zipCode"
                                                        placeholder="Postal/Zip code"
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                             </b-col>
                                            
                                              <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                <b-col cols="12" xl="12" md="12" class="mt-30">
                                          <h5>Street name(Optional)</h5>
                                        </b-col>
                                                 <b-form-group label-for="streetName" >
                                                        <b-form-input
                                                        v-model="form.streetName"
                                                        placeholder="Street name"
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                            </b-col>
                                             <b-col lg="6" md="6" sm="6" xs="6" cols="12" >
                                              <b-col cols="12" xl="12" md="12" class="mt-30">
                                          <h5>P.O. Box(Optional)</h5>
                                        </b-col>
                                                <b-form-group label-for="POBox" >
                                                        <b-form-input
                                                        v-model="form.POBox"
                                                        placeholder="P.O. Box"
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                             </b-col>
                                              <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                <b-col cols="12" xl="12" md="12" class="mt-30">
                                          <h5>Street number(Optional)</h5>
                                        </b-col>
                                                 <b-form-group label-for="streetNumber" >
                                                        <b-form-input
                                                        v-model="form.streetNumber"
                                                        placeholder="Street number"
                                                        class="input-outline-bleu-border"
                                                        ></b-form-input>
                                                    </b-form-group>
                                            </b-col>

                                       
                                    </b-row>-->
            <b-col class="text-right mt-30" cols="12" xl="12" md="12">
              <b-button
                variant="primary"
                class="addContainer"
                @click="updateBooking()"
              >
                Save
              </b-button>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Upload PDF</h5>
            </b-col>
            <b-col cols="12" xl="10" md="10">
              <b-form-file
                placeholder="PDF"
                type="file"
                v-model="file"
                name="file"
                accept=".pdf"
              ></b-form-file>
            </b-col>
              <b-col cols="12" xl="2" md="2">
               <b-button size="md" class="" v-if="form.pdf && form.pdf!=null && form.pdf!=undefined" @click="downloadFile(form.pdf)"> <feather-icon icon="DownloadIcon" size="18"/></b-button>
            </b-col>

            <b-col class="text-right mt-30" cols="12" xl="12" md="12">
              <b-button
                variant="primary"
                class="addContainer"
                @click="uploadFile()"
              >
                Save PDF
              </b-button>
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>
    <sidebar-add-new-customer @update-client="getAllClient()" />
    <sidebar-add-new-agency @update-prospect="getAllCommodityAndContainers()" />
    <sidebar-add-new-commodity @update-payment="getAllCommodity()" />
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSpinbutton,
  BFormDatepicker,
  BFormRadioGroup,
  BFormRadio,
  BFormFile
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddNewCustomer from "../../composants/sidebar/SidebarAddNewCustomer.vue";
import SidebarAddNewAgency from "../../composants/sidebar/SidebarAddNewAgency.vue";
import SidebarAddNewCommodity from "../../composants/sidebar/SidebarAddNewCommodity.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";

export default {
  components: {
    BFormDatepicker,
    BFormSpinbutton,
    BCardActions,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    BFormFile,
    Logo,
    SidebarAddNewCustomer,
    SidebarAddNewAgency,
    SidebarAddNewCommodity,
    ToastificationContent,
    BFormRadioGroup,
    BFormRadio,
  },
  data() {
    return {
      file: null,
      form: {
        reference: null,
        quotation: this.$router.history.current.query.id,
        customer: null,
        loadingPort: null,
        dischargePort: null,
        incoterm: null,
        transportType: null,
        departureAddressCity: null,
        TransportDischarge: null,
        arrivalAddressCity: null,
        commodityContainer: [
          {
            selectedOption: null,
            commodity: {
              title: null,
              description: null,
              requiresTemperatureControl: false,
              requiresSpecialEquipment: false,
              dangerousCargo: false,
              commodityClass: null,
              commodityUn: null,
              temperatureControl: null,
              specialEquipment: {
                height: null,
                width: null,
                length: null,
              },
            },
            container: {
              containers: [],
              containerType: null,
              quantity: 1,
              weight: "1000.000",
              isOwnedByShipper: false,
            },
          },
        ],
        effectiveDate: null,
        expiryDate: null,
        customerCode: "",
        companyName: "",
        country: "",
        zipCode: "",
        streetName: "",
        POBox: "",
        streetNumber: "",
        merchandiseType: null,
      },
      incotermArray: ["FOB", "CFR", "EXW", "FCA", "DAP"],
      TransportLoadingOptions: ["Transport Marchant", "Transport Carrier"],
      merchandise: ["gaz", "pétrol", "sucre", "mais"],
      ports: [],
      departurePorts: [],
      arrivalPorts: [],
      commodities: [],
      classes: [],
      uns: [],
      containers: [],
      acceptTerm: false,
      selectedOption: null,
    };
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  created() {
    this.getData();
    this.getPorts();
    this.getCommodities();
    this.getClasses();
    this.getUns();
    this.getContainers();
  },

  methods: {
    async getData() {
      const containers = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/containers"
      );
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/bookings?id=" +
          this.$router.history.current.query.id
      );
      this.form = JSON.parse(JSON.stringify(response.data.data));
      console.log(response.data.data);
      this.form.customer = response.data.data.customer._id;
      this.form.arrivalPortAgent = this.form.arrivalPortAgent.agent.user;
      this.form.departurePortAgent = this.form.departurePortAgent.agent.user;
      this.form.commodityContainer.forEach((element, index) => {
        if (element.commodity.requiresTemperatureControl) {
          this.$set(
            this.form.commodityContainer[index],
            "selectedOption",
            "radio1"
          );
          const filterCon = containers.data.data
            .filter((item) => item.frigorifique === true)
            .map((item) => ({
              label: item.title + " " + item.type,
              value: { _id: item._id, title: item.title },
            }));
          this.$set(
            this.form.commodityContainer[index].container,
            "containers",
            filterCon
          );
        }
        if (element.commodity.requiresSpecialEquipment) {
          this.$set(
            this.form.commodityContainer[index],
            "selectedOption",
            "radio2"
          );
          this.$set(
            this.form.commodityContainer[index].container,
            "containers",
            this.containers
          );
        }
        if (element.commodity.dangerousCargo) {
          this.$set(
            this.form.commodityContainer[index],
            "selectedOption",
            "radio3"
          );
          this.$set(
            this.form.commodityContainer[index].container,
            "containers",
            this.containers
          );
        }
        if (!element.commodity.requiresSpecialEquipment) {
          this.$set(
            this.form.commodityContainer[index].commodity,
            "specialEquipment",
            {
              height: null,
              width: null,
              length: null,
            }
          );
        }
      });
      const dateObject1 = new Date(this.form.effectiveDate);
      this.form.effectiveDate = dateObject1.toISOString().split("T")[0];
      const dateObject2 = new Date(this.form.expiryDate);
      this.form.expiryDate = dateObject2.toISOString().split("T")[0];
      if (
        this.form.customerCode ||
        this.form.companyName ||
        this.form.country
      ) {
        this.selectedOption = "selectPriceOwner";
      } else {
        this.selectedOption = "iamPriceOwner";
      }
    },
    async getPorts() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/ports"
      );
      this.ports = response.data.data.map((item) => ({
        _id: item._id,
        portAgent: item.portAgent._id,
        title: item.title,
      }));
      this.departurePorts = this.ports.filter(
        (item) => item.portAgent !== this.form.arrivalPortAgent
      );
      this.arrivalPorts = this.ports.filter(
        (item) => item.portAgent !== this.form.departurePortAgent
      );
    },
    async getCommodities() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/commodities"
      );
      this.commodities = response.data.data.map((item) => item.title);
    },
    async getClasses() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/classes"
      );
      this.classes = response.data.data.map((item) => item.title);
    },
    async getUns() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/uns"
      );
      this.uns = response.data.data.map((item) => item.title);
    },
    async getContainers() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/containers"
      );
      this.containers = response.data.data.map((item) => ({
        label: item.title + " " + item.type,
        value: { _id: item._id, title: item.title },
      }));
      this.form.commodityContainer.forEach((element) => {
        element.container.containers = this.containers;
      });
    },
    updateArrivalPorts(port) {
      this.form.departurePortAgent = port ? port.portAgent : null;
      this.form.loadingPort = port ? port.title : null;
      this.arrivalPorts = port
        ? this.ports.filter((item) => item.portAgent !== port.portAgent)
        : this.ports;
    },
    updateDeparturePorts(port) {
      this.form.arrivalPortAgent = port ? port.portAgent : null;
      this.form.dischargePort = port ? port.title : null;
      this.departurePorts = port
        ? this.ports.filter((item) => item.portAgent !== port.portAgent)
        : this.ports;
    },
    updateIncoterm(incoterm) {
      if (incoterm === null || incoterm === "FOB" || incoterm === "CFR") {
        this.form.transportType = null;
        this.form.arrivalAddressCity = null;
        this.form.departureAddressCity = null;
      }
    },
    updateContainer(index, container) {
      if (container) {
        this.form.commodityContainer[index].container.containerType =
          container.label;
      }
    },
    updateTransport(transport) {
      if (transport === "Transport Marchant") {
        this.form.arrivalAddressCity = null;
        this.form.departureAddressCity = null;
      }
    },
    async updateSelectedOption(index) {
      if (this.form.commodityContainer[index].selectedOption === "radio1") {
        const response = await axios.get(
          "https://mtl-feeder-nodejs.onrender.com/api/containers"
        );
        this.form.commodityContainer[index].container.containers =
          response.data.data
            .filter((item) => item.frigorifique === true)
            .map((item) => ({
              label: item.title + " " + item.type,
              value: { _id: item._id, title: item.title },
            }));
        this.form.commodityContainer[index].container.containerType = null;
        this.form.commodityContainer[
          index
        ].commodity.requiresTemperatureControl = true;
        this.form.commodityContainer[
          index
        ].commodity.requiresSpecialEquipment = false;
        this.form.commodityContainer[index].commodity.dangerousCargo = false;
        this.form.commodityContainer[index].commodity.commodityClass = null;
        this.form.commodityContainer[index].commodity.commodityUn = null;
        this.form.commodityContainer[index].commodity.specialEquipment.height =
          null;
        this.form.commodityContainer[index].commodity.specialEquipment.width =
          null;
        this.form.commodityContainer[index].commodity.specialEquipment.length =
          null;
      } else if (
        this.form.commodityContainer[index].selectedOption === "radio2"
      ) {
        this.form.commodityContainer[index].container.containers =
          this.containers;
        this.form.commodityContainer[
          index
        ].commodity.requiresTemperatureControl = false;
        this.form.commodityContainer[
          index
        ].commodity.requiresSpecialEquipment = true;
        this.form.commodityContainer[index].commodity.dangerousCargo = false;
        this.form.commodityContainer[index].commodity.commodityClass = null;
        this.form.commodityContainer[index].commodity.commodityUn = null;
        this.form.commodityContainer[index].commodity.temperatureControl = null;
      } else if (
        this.form.commodityContainer[index].selectedOption === "radio3"
      ) {
        this.form.commodityContainer[index].container.containers =
          this.containers;
        this.form.commodityContainer[
          index
        ].commodity.requiresTemperatureControl = false;
        this.form.commodityContainer[
          index
        ].commodity.requiresSpecialEquipment = false;
        this.form.commodityContainer[index].commodity.dangerousCargo = true;
        this.form.commodityContainer[index].commodity.specialEquipment.height =
          null;
        this.form.commodityContainer[index].commodity.specialEquipment.width =
          null;
        this.form.commodityContainer[index].commodity.specialEquipment.length =
          null;
        this.form.commodityContainer[index].commodity.temperatureControl = null;
      }
    },
    financial(item) {
      item.container.weight = Number.parseFloat(item.container.weight).toFixed(
        3
      );
      return Number.parseFloat(item.container.weight).toFixed(3);
    },
    addCommodityContainer() {
      this.form.commodityContainer.push({
        commodity: {
          title: null,
          description: null,
          requiresTemperatureControl: false,
          requiresSpecialEquipment: false,
          dangerousCargo: false,
          commodityClass: null,
          commodityUn: null,
          temperatureControl: null,
          specialEquipment: {
            height: null,
            width: null,
            ength: null,
          },
        },
        container: {
          containers: this.containers,
          containerType: null,
          quantity: 1,
          weight: "1000.000",
          isOwnedByShipper: false,
        },
      });
    },
    deleteCommodityContainer(index) {
      this.form.commodityContainer.splice(index, 1);
    },
    changeRadio() {
      if (this.selectedOption === "iamPriceOwner") {
        this.form.customerCode = "";
        this.form.companyName = "";
        this.form.country = "";
        this.form.zipCode = "";
        this.form.streetName = "";
        this.form.POBox = "";
        this.form.streetNumber = "";
      }
    },
    async uploadFile() {
      if (!this.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Please select a file`,
            icon: "UserIcon",
            variant: "warning",
          },
        });
      } else {
        const allowedExtensions = [".pdf"];
        const fileExtension = this.file.name.slice(
          this.file.name.lastIndexOf(".")
        );
        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `PDF file only`,
              icon: "UserIcon",
              variant: "warning",
            },
          });
        } else {
          const formData = new FormData();
          formData.append("pdf", this.file);
          try {
            const response = await axios.put(
              `https://mtl-feeder-nodejs.onrender.com/api/bookings/${this.$router.history.current.query.id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `File submitted`,
                icon: "UserIcon",
                variant: "success",
              },
            });
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    downloadFile(url) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "File.pdf";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    updateBooking() {
      const id = this.$router.history.current.query.id;
      // if (this.selectedOption) {
      // if (this.selectedOption === "selectPriceOwner" &&
      // (!this.form.customerCode || this.form.customerCode === "") &&
      // (!this.form.country || this.form.country === "") &&
      // (!this.form.companyName || this.form.companyName === "")) {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: "Please Fill the form",
      //         icon: "EditIcon",
      //         variant: "warning",
      //       },
      //     });
      // }
      // else {
      const filteredObj = Object.fromEntries(
        Object.entries(this.form).filter(
          ([key, value]) => value !== null && value !== ""
        )
      );
      filteredObj.commodityContainer.forEach((item) => {
        item.commodity = Object.fromEntries(
          Object.entries(item.commodity).filter(
            ([key, value]) => value !== null
          )
        );
        if (item.commodity.requiresSpecialEquipment === false) {
          delete item.commodity.specialEquipment;
        }
      });
      // if (this.form.customerCode) {
      //     axios.get('https://mtl-feeder-nodejs.onrender.com/api/customers', {
      //         params : {id : JSON.parse(localStorage.getItem("userData")).user.customer._id }
      //     })
      //     .then((response) => {
      //         if (this.form.customerCode === response.data.data[0].code) {
      //           axios
      //     .put(
      //         `https://mtl-feeder-nodejs.onrender.com/api/bookings/${id}`, filteredObj
      //     )
      //             .then((response) => {
      //               this.$toast({
      //               component: ToastificationContent,
      //               props: {
      //                 title: "Booking updated",
      //                 icon: "EditIcon",
      //                 variant: "success",
      //               },
      //             });
      //             })
      //             .catch((error) => {
      //             this.$toast({
      //               component: ToastificationContent,
      //               props: {
      //                 title: "Error during update",
      //                 icon: "EditIcon",
      //                 variant: "danger",
      //               },
      //             });
      //           })
      //         }
      //         else {
      //           this.$toast({
      //               component: ToastificationContent,
      //               props: {
      //                 title: "Invalid customer code",
      //                 icon: "EditIcon",
      //                 variant: "warning",
      //               },
      //             });
      //         }
      //     })
      //     .catch((error) => {
      //     })
      // }
      // else {
      axios
        .put(
          `https://mtl-feeder-nodejs.onrender.com/api/bookings/${id}`,
          filteredObj
        )
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
      // }
      // }
      // }
      // else {
      //     this.$toast({
      //           component: ToastificationContent,
      //           props: {
      //             title: "Please Verify the form",
      //             icon: "EditIcon",
      //             variant: "warning",
      //           },
      //         });
      // }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.commodity-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
.customer-row {
  padding: 0 1.1rem !important;
}
</style>

